import {
  Datagrid,
  Filter,
  List,
  SaveButton,
  SearchInput,
  SimpleForm,
  TextField,
  TextInput,
  Toolbar,
  useTranslate,
  useRecordContext,
} from 'react-admin'

import { DialogForm } from '../components/DialogForm'

const SaveOnlyToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton {...props} />
  </Toolbar>
)

export const LotsEditDialog = () => {
  const record = useRecordContext()
  const translate = useTranslate()
  if (!record) return null

  return (
    <DialogForm
      title={translate('hs.compliance.lots.title', {
        copro_code: record.copro_code,
      })}
      id={record.id}
    >
      <SimpleForm
        toolbar={<SaveOnlyToolbar />}
        resource="compliance/lots"
        basePath="/"
      >
        <TextInput source="address" />
        <TextInput source="nb_main_lots" />
        <TextInput source="nb_extra_lots" />
      </SimpleForm>
    </DialogForm>
  )
}

const LotsListFilter = (props) => (
  <Filter {...props}>
    <SearchInput source="copro_code" />
  </Filter>
)

export const LotsList = (props) => (
  <List
    {...props}
    exporter={false}
    hasCreate={false}
    perPage={100}
    filters={<LotsListFilter />}
  >
    <Datagrid bulkActionButtons={false}>
      <TextField source="copro_code" />
      <TextField source="address" />
      <TextField source="nb_main_lots" />
      <TextField source="nb_extra_lots" />
      <LotsEditDialog {...props} />
    </Datagrid>
  </List>
)
